<template>
  <div class="q-mt-md">
    <DataTable
      name="notificationSettingTable"
      :data="tableData"
      :columns="columns"
      :columnItems="columnItems"
      rowKey="id"
      :filter-placeholder="$t('Search for channels')"
    >
      <template v-slot:body-cell-enabled="{ props }">
        <Td :props="props">
          <Badge
            :label="props.row.enabled ? $t('Enabled') : $t('Disabled')"
            :color="props.row.enabled ? 'success' : 'warning'"
          />
        </Td>
      </template>
      <template v-slot:body-cell-actions="{ props }" v-if="$can('ModifySettings')">
        <Td :props="props">
          <Button icon="edit" flat @click="openModal(props.row.id)" />
          <Button icon="delete" flat @click="openDeleteModal(props.row.id)" />
        </Td>
      </template>
    </DataTable>
  </div>
</template>

<script>
import Badge from '@design-system/components/Badge';
import Button from '@design-system/components/Button';
import DataTable from '@design-system/components/DataTable/DataTable';
import Td from '@design-system/components/DataTable/Td';

const messages = {
  en: {
    'Search for channels': 'Search for channels',
    Name: 'Name',
    Format: 'Format',
    To: 'To',
    Status: 'Status',
    Enabled: 'Enabled',
    Disabled: 'Disabled',
    // Edit: 'Edit',

    Actions: 'Actions',
  },
  ja: {
    'Search for channels': 'チャネルを検索',
    Name: '名前',
    Format: 'フォーマット',
    To: '宛先',
    Status: 'ステータス',
    Enabled: '有効',
    Disabled: '無効',
    // Edit: '変更する',
    Actions: 'アクション',
  },
};

export default {
  name: 'DataTableNotificationSettings',
  i18n: { messages },
  components: {
    Badge,
    Button,
    DataTable,
    Td,
  },
  props: {
    tableData: Array,
  },
  computed: {
    columnItems() {
      return [
        { label: this.$t('Name'), key: 'name', visible: true },
        { label: this.$t('Type'), key: 'typeLabel', visible: true },
        { label: this.$t('To'), key: 'to', visible: true },
        { label: this.$t('Format'), key: 'formatLabel', visible: true },
        { label: this.$t('Status'), key: 'enabled', visible: true },
        { label: this.$t('Actions'), key: 'actions', visible: true },
      ];
    },

    columns() {
      const columns = [
        {
          name: 'name',
          align: 'left',
          label: this.$t('Name'),
          field: 'name',
          sortable: true,
        },
        {
          name: 'typeLabel',
          align: 'left',
          style: 'white-space:nowrap',
          label: this.$t('Type'),
          field: 'typeLabel',
          sortable: true,
        },
        {
          name: 'to',
          align: 'left',
          style: 'min-width:250px;white-space:pre-line',
          label: this.$t('To'),
          field: 'to',
          sortable: true,
        },
        {
          name: 'formatLabel',
          align: 'left',
          label: this.$t('Format'),
          field: 'formatLabel',
          style: 'white-space:nowrap',
          headerStyle: 'white-space:nowrap',
        },
        {
          name: 'enabled',
          align: 'left',
          label: this.$t('Status'),
          field: 'enabled',
          sortable: true,
          style: 'white-space:nowrap',
          headerStyle: 'white-space:nowrap',
        },
      ];

      if (this.$can('ModifySettings')) {
        columns.push({
          name: 'actions',
          label: this.$t('Actions'),
          required: true,
          align: 'center',
          style: 'width:80px;white-space:nowrap',
        });
      }

      return columns;
    },
  },
  methods: {
    openModal(id) {
      this.$emit('openModal', id);
    },
    openDeleteModal(id) {
      console.log('id', id);
      this.$emit('openDeleteModal', id);
    },
  },
};
</script>

<style lang="scss" scoped></style>
